export default (formData, countries) => {
  const { phoneCountry, phoneNumber, ...formattedData } = formData;
  const country = countries.find((country) => country.name === formData.country);
  formattedData.country = country;
  formattedData.phoneInfo = {
    phoneCountry: countries.find((country) => country.name === phoneCountry)?.name || phoneCountry,
    phoneNumber,
  };
  return formattedData;
};
